import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const PaginationWrapper = styled.div`
  padding: 50px 0;
`;

export const containerStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const pageItemStyle = (theme: Theme) => css`
  text-align: center;
  font-weight: bold;
  list-style: none;

  padding: 0px;
  border: 1px solid ${theme.color.light.shade};
  border-right-width: 0px;
  display: inline-block;
  min-width: 45px;

  a {
    width: 100%;
    height: 100%;
    display: block;
    padding: 12px 15px;

    ${mediaQuery('tablet')} {
      padding: 12px 12px;
      font-size: 14px;
    }

    ${mediaQuery('small')} {
      padding: 12px 9px;
    }

    ${mediaQuery('phone')} {
      padding: 12px 8px;
    }
  }

  &.disabled-navigation {
    display: none;
  }

  padding: 0;

  ${mediaQuery('tablet')} {
    min-width: auto;
  }

  &:last-child {
    border-right-width: 1px;
  }

  &:hover:not(.disabled) {
    cursor: pointer;
    /* color: ${theme.color.blue.default}; */
  }

  &.selected {
    background: ${theme.color.blue.default};
    color: ${theme.color.light.default};

    a {
      color: inherit;
    }
  }

  &.disabled {
    display: none;
  }
`;
